import React from 'react';
import './NewCorporationDetail.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import WebLinkList from './WebLinkList';
import logComponent from '../../common/logComponent';

export default function NewCorporationDetail({ corporation, linkToFacility }) {

  if (logComponent('NewCorporationDetail')) { console.debug('NewCorporationDetail rendered'); }

  const handleFacilityClick = (e) => {
    if (logComponent('NewCorporationDetail')) { console.debug('NewCorporationDetail handleFacilityClick'); }
    const { facilityId } = e.currentTarget.dataset;

    // get facility based on id
    // NOTE: we want == in this case b/c the facilityId coming from the
    // dataset is a string, but the value in the linkedFacility is a number
    const targetFacility = corporation.uiData.linkedFacilities.find(facility => 
      facility.salesforceAccountId &&
      facility.salesforceAccountId == facilityId); // eslint-disable-line

    linkToFacility(targetFacility);
  }

      
  return (
    <div className="New-Corporation-Detail">
      <h4 className="New-Corporation-Detail__heading">{corporation.name}</h4>
      <p className="New-Corporation-Detail__instructions">Please accept or reject this new corporation based on the information below.</p>
      <dl className="New-Corporation-Detail__list">
        <dt>Corporation Name</dt>
        <dd>
          {
            corporation.name ||
            <span className="New-Corporation-Detail__empty-field">Not Provided</span>
          }</dd>
        <dt>About Us</dt>
        <dd>
          {
            corporation.aboutUs ||
            <span className="New-Corporation-Detail__empty-field">Not Provided</span>
          }</dd>
        <dt>Postal Code</dt>
        <dd>
          {
            corporation.postalCode ||
            <span className="New-Corporation-Detail__empty-field">Not Provided</span>
          }</dd>
        <dt>Industry Type</dt>
        <dd>
          {
            corporation.industryType ||
            <span className="New-Corporation-Detail__empty-field">Not Provided</span>
          }</dd>
        <dt>Salesforce Account ID</dt>
        <dd>
          {
            corporation.salesforceAccountId ||
            <span className="New-Corporation-Detail__empty-field">Not Provided</span>
          }
        </dd>
        <dt>Web Links</dt>
        <dd>
          {
            corporation.webLinks.length === 0 ?
              <span className="New-Corporation-Detail__empty-field">Not Provided</span> :
              <WebLinkList links={corporation.webLinks} />
          }
        </dd>
        <dt>Linked Facilities</dt>
        <dd>
          {
            corporation.uiData.linkedFacilities.length === 0 ?
              <span className="New-Corporation-Detail__empty-field">Not Provided</span> :
              <ul className="New-Corporation-Detail__facility-list">
                {
                  corporation.uiData.linkedFacilities.map(facility =>
                    <li
                      className="New-Corporation-Detail__facility-item"
                      key={facility.salesforceSiteId}>
                      <span className="New-Corporation-Detail__facility-id">{facility.salesforceSiteId}</span>
                      <span className="New-Corporation-Detail__facility-name">
                        {facility.name}
                        {
                          (!facility.status || facility.status !== 'rejected') &&
                          <button
                            className="New-Corporation-Detail__facility-link"
                            data-facility-id={facility.salesforceAccountId}
                            onClick={handleFacilityClick}>
                            <FontAwesomeIcon icon="external-link-alt" />
                          </button>
                        }
                      </span>
                    </li>
                  )
                }
              </ul>
          }
        </dd>
      </dl>
    </div>
  );
}
